import React from "react"
import { ImgS } from "ui-seeker/core"
import { countryCodeFactory, translateCountryCode } from "ui-seeker/utils"

import { IMAGE } from 'app/@common/constants'


const TmpFlag = ({ countryCode }) => {

    const img = countryCode === 'GLOBE' ? `${IMAGE.ASSETS}/flags/globe.png` : `${IMAGE.ASSETS}/flags/${countryCode.toLowerCase()}.svg`

    return <abbr style={{ display: 'inline-block', verticalAlign: 'middle', width: '20px', textAlign: 'center', lineHeight: '0', marginRight: '5px' }}>
        <ImgS src={img} alt={`Flag of ${countryCode}`} style={{ display: "inline-block", height: "1em", verticalAlign: "middle", maxWidth: '100%' }} />
    </abbr>
}

const TmpCountryText = ({ countryText, label }) =>
    <abbr style={{ display: 'inline-block', verticalAlign: 'middle' }}>{` ${countryText}`} {label}</abbr>

export const formatWithFlag = (countryCode, { label='', countryName=false } = {}) => {
    const cc = (countryCode === "COM" || countryCode === "None") ? "GLOBE" : countryCodeFactory(countryCode)
    if (cc === null) return ''

    const countryText = countryName ? cc ==="GLOBE" ? "COM" : translateCountryCode(cc) : ''

    return <>
        <TmpFlag countryCode={cc} /> <TmpCountryText countryText={countryText} label={label} />
    </>
}